import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allAgents: [],
};

const getters = {
  GET_ALL_AGENTS(state) {
    return state.allAgents;
  },
  GET_AGENT: (state) => (id) => {
    return state.allAgents.find((cat) => cat.id === id);
  },
};

const mutations = {
  SET_ALL_AGENTS: (state, payload) => (state.allAgents = payload),
};

const actions = {
  async GET_ALL_AGENTS({ commit }) {
    try {
      const { data } = await PbxHttpClient.get("/clients/show/agents_select/");

      commit("SET_ALL_AGENTS", data.data);
      return categoriesList;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
